<template>
  <div v-if="screenData" class="view tv dark">
    <MastHead :data="screenData" />
    <Screen :data="tv2Screen1">
      <StudyParameters :data="screenData" />
    </Screen>
    <Screen :data="tv3screen1">
      <BarChart :commuters="tv3screen1.data.entries" :colors="tv3screen1.data.colors" />
    </Screen>
    <Screen :data="tv4Screen1">
      <LineChart :commuters="tv4Screen1.data.entries" :colors="tv4Screen1.data.colors" />
    </Screen>
    <IntersticeMastHead />
    <IntersticeTwo />
    <IntersticeThree />
  </div>
</template>

<script>
import Tv from './TvMixin';
import { extendedTimeRangesCaptions, timeRangesCaptions } from '@/pure/ComputedData';

export default {
  mixins: [Tv],

  data() {
    return {
      state: '',
      lastState: '',
      distribution: '',
      index: -1,
      screenData: null,
    };
  },

  computed: {
    tv2Screen1() {
      const { collaboratorsCount, unrecognizedCount, offLimitCount, excludedAddresses } = this.screenData;
      return {
        heading: {
          caption: this.$t('settingHelper.studyParameters'),
          icon: 'cog',
        },
        footer: {
          entries: [
            {
              value: collaboratorsCount,
              description: this.$t('parameters.totalCollaborators', collaboratorsCount),
            },
            {
              value: collaboratorsCount - unrecognizedCount - offLimitCount,
              description: this.$t('parameters.accountedCollaborators', collaboratorsCount - unrecognizedCount - offLimitCount),
            },
            {
              value: unrecognizedCount,
              description: this.$t('parameters.unrecognizedAddress', unrecognizedCount),
            },
            {
              value: offLimitCount,
              description: this.$t('parameters.offlimitAddress', offLimitCount),
            },
            {
              value: excludedAddresses,
              description: this.$t('parameters.excludedAddress', excludedAddresses),
            },
          ],
        },
      };
    },

    tv3screen1() {
      const { collaboratorsByRegion } = this.screenData;
      const entries = collaboratorsByRegion
        .sort((a, b) => {
          return b.count - a.count;
        })
        .slice(0, 8)
        .map(item => {
          const { caption, percentage } = item;
          return [caption || this.$t('notProvided'), percentage];
        });
      return {
        heading: {
          caption: this.$t('collaboratorLocation'),
          icon: 'people',
        },
        data: {
          entries,
          colors: ['#D60808', '#D8D8D8', '#f1e7ca', '#8b8181', '#9a054a', '#602376', '#7874b5', '#ed700a'],
        },
      };
    },

    tv4Screen1() {
      const colors = ['#ffffff', '#D60808', '#7773b3', '#602376', '#9a054a', '#262631', '#D60808', '#7773b3', '#602376', '#9a054a'];
      const { collaboratorsByTimeRanges, sites, useExtendedTimeRanges } = this.screenData;
      const headerCaption = useExtendedTimeRanges ? extendedTimeRangesCaptions : timeRangesCaptions;
      const entries = sites.map(site => {
        const { collaboratorsByTimeRanges } = site.details;
        const commuters = collaboratorsByTimeRanges.map((item, idx) => {
          return [headerCaption[idx], item.count];
        });
        commuters.id = site.id;
        commuters.color = colors[site.index + 1];
        return commuters;
      });
      const firstCol = collaboratorsByTimeRanges.map((item, idx) => {
        return [headerCaption[idx], item.count];
      });
      firstCol.id = 'first-col';
      firstCol.color = colors[0];
      entries.unshift(firstCol);
      return {
        heading: {
          caption: this.$t('collaboratorTimeByLocation'),
          icon: 'clock',
        },
        data: {
          entries,
          colors: ['#ffffff', '#D60808', '#602376', '#7773b3', '#9a054a'],
        },
      };
    },

    environmental() {
      const { sites, environmentalImpact } = this.screenData;
      const entries = sites.map((site, idx) => {
        const evolution = Math.round(((site.details.environmentalImpact - environmentalImpact) / environmentalImpact) * 100 * 100) / 100;

        return [
          this.buildSiteBlock(site, idx),
          {
            value: site.details.environmentalImpact,
            sub: ' kg',
          },
          {
            trend: evolution === 0 ? 0 : evolution < 0 ? 'down' : 'up',
            value: Math.abs(evolution),
            sub: '%',
          },
        ];
      });
      return {
        data: {
          specifications: [
            {
              caption: this.$t('CurrentSiteName'),
              className: {
                big: true,
              },
            },
            {
              type: 'heading',
              caption: environmentalImpact,
              sub: ' kg',
            },
            {
              type: 'heading',
              caption: '',
            },
          ],
          entries,
        },
      };
    },
  },

  mounted() {
    const id = this.$route.params.studyId;
    this.$store.dispatch('getStudyResult', { id }).then(() => {
      this.screenData = this.$store.getters.screen();
    });
  },
};
</script>
